import { FaPlus, FaTrash } from "react-icons/fa";
import { AnimatePresence, motion } from "framer-motion";

export default function TakeProfitSection({
  tps,
  setTps,
  tpError,
  signalActionStatus,
}) {
  const addTp = () => {
    if (tps.length >= 5) return;
    const newId = tps.length > 0 ? tps[tps.length - 1].id + 1 : 1;
    setTps([...tps, { id: newId, price: "" }]);
  };

  const removeTp = (id) => {
    setTps(tps.filter((tp) => tp.id !== id));
  };

  const sanitizeNumber = (value) => {
    if (!value) return "";

    let cleaned = value.replace(/[^0-9.]/g, "");

    const parts = cleaned.split(".");
    if (parts.length > 2) {
      cleaned = parts[0] + "." + parts.slice(1).join("");
    }

    if (cleaned.startsWith("0") && !cleaned.startsWith("0.")) {
      cleaned = cleaned.replace(/^0+/, "");
      if (cleaned === "") cleaned = "0";
    }

    return cleaned;
  };

  const updatePrice = (id, value) => {
    const valid = sanitizeNumber(value);
    setTps(tps.map((tp) => (tp.id === id ? { ...tp, price: valid } : tp)));
  };

  const updateCurrent = (id) => {
    const currentPrice = (Math.random() * 100).toFixed(5);
    setTps(
      tps.map((tp) => (tp.id === id ? { ...tp, price: currentPrice } : tp)),
    );
  };

  return (
    <section className="bg-white rounded-xl shadow-lg border border-gray-200 p-5">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-bold text-lg">Take Profit Targets</h3>
        <button
          onClick={addTp}
          disabled={tps.length >= 5}
          className={`px-3 py-2 rounded-lg text-sm font-semibold flex items-center ${
            tps.length >= 5
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "bg-green-100 text-green-700 hover:bg-green-200"
          }`}
        >
          <FaPlus className="mr-1" /> Add TP
        </button>
      </div>

      {/* TP List */}
      <div className="space-y-3">
        <AnimatePresence>
          {tps.map((tp, index) => (
            <motion.div
              key={tp.id}
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -15 }}
              transition={{ duration: 0.2 }}
              className="tp-item flex items-center space-x-3"
            >
              {/* Number Circle */}
              <p className="bg-green-100 text-green-700 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold">
                {index + 1}
              </p>

              {/* Input */}
              <div className="flex-1">
                <div className="relative">
                  <input
                    type="number"
                    step="0.00001"
                    placeholder={`TP${index + 1} Price`}
                    value={tp.price}
                    onChange={(e) => updatePrice(tp.id, e.target.value)}
                    className={`w-full p-3 pr-24 border rounded-lg outline-none ${
                      tpError.includes(tp.id)
                        ? "border-red-500 focus:border-red-500"
                        : "border-gray-300 focus:border-primary"
                    }`}
                  />

                  <button
                    type="button"
                    onClick={() => updateCurrent(tp.id)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-primary bg-light px-2 py-1 rounded"
                  >
                    Current: <span>{tp.price || "--"}</span>
                  </button>
                </div>

                {tpError.includes(tp.id) && (
                  <p className="text-red-500 text-xs mt-1">
                    {signalActionStatus === "buy"
                      ? "TP price must be higher than entry price"
                      : "TP price must be lower than entry price"}
                  </p>
                )}
              </div>

              {/* Remove Button */}
              <button
                onClick={() => removeTp(tp.id)}
                className="text-red-500 p-2 hover:text-red-600"
              >
                <FaTrash />
              </button>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </section>
  );
}
